module.exports = __webpack_public_path__ + "img/emoNature.7845b649.svg";